import { Container, TEMPLATE, Empty } from './styled'

function CardGrid({ template = TEMPLATE.MEDIUM, children, empty, className, dataTestId }) {
  return (
    <Container template={template} className={className} data-testid={dataTestId}>
      {empty && <Empty>{empty}</Empty>}
      {children}
    </Container>
  )
}

function CardGridSmall(props) {
  return <CardGrid dataTestId="grid_cards" template={TEMPLATE.SMALL} {...props} />
}

function CardGridMedium(props) {
  return <CardGrid dataTestId="grid_cards" template={TEMPLATE.MEDIUM} {...props} />
}

function CardGridLarge(props) {
  return <CardGrid dataTestId="grid_cards" template={TEMPLATE.LARGE} {...props} />
}

function CardGridExtraLarge(props) {
  return <CardGrid dataTestId="grid_cards" template={TEMPLATE.EXTRA_LARGE} {...props} />
}

CardGrid.Small = CardGridSmall
CardGrid.Medium = CardGridMedium
CardGrid.Large = CardGridLarge
CardGrid.ExtraLarge = CardGridExtraLarge

export default CardGrid
